/** @jsx jsx */
import React from "react"
import { jsx, Link as TLink } from "theme-ui"
import { Box } from "@theme-ui/components"
import { Link } from "gatsby"
import ItemTags from "@lekoarts/gatsby-theme-minimal-blog/src/components/item-tags"
import getIcons from "../../../icons/icon-list"

const iconList = getIcons()

type ProjectsListItemProps = {
  post: {
    slug: string
    title: string
    icons: string
    excerpt: string
  }
}

const ProjectsListItem = ({ project }: ProjectsListItemProps) => {
  const [myIcon] = iconList.filter(myIcon => myIcon.name === project.icon)
  return (
    <Box mb={4}>
      <TLink as={Link} to={project.slug} sx={{ fontSize: [1, 2, 3], color: `text` }}>
      <Box sx={{display: 'inline', p:2}}><img src={myIcon.icon} sx={{ height: ['18px', '24px']}}/></Box>
        {project.title}
      </TLink>
    </Box>
  )
}

export default ProjectsListItem
